import React from "react";
import { Link } from "react-router-dom";
import "./About.css";

const About = () => {
  return (
    <div
      className='about mx-auto md:w-2/3 xs:w-10/12
     md:p-16 xs:p-3 mt-16 border-2  '>
      <div className='about__info xs:py-6'>
        <h1 className='text-center text-white md:mb-5 xs:my-4 font-lg font-bold font-serif'>
          What is Payda?
        </h1>
        <p className='font-md md:px-4 md:py-3 xs:p-1 xs:mt-7 text-white'>
          Payda Afghanistan is a platform which has been developed by a young
          experienced and talented Afghan developer for the sake of bridging the
          gaps between Loser and Finder.
        </p>{" "}
        <p className='font-md md:px-4 xs:p-1 text-white'>
          {" "}
          Zubair Omer is a young experienced Software Developer with hared
          values and visions. He is head of design at @ColdTech. He mainly
          focuses on web development and restful API services. He loves to keep
          everything simple and clean.
        </p>
      </div>
      <div className='flex md:justify-end md:items-center xs:justify-center'>
        <Link
          to='/'
          className='text-color bg-white text-decoration-none font-semibold p-2 px-3 xs:mt-12 md:mr-12 '>
          Go Back
        </Link>
      </div>
    </div>
  );
};

export default About;
